"use client";

import type React from "react";
import { forwardRef } from "react";
import Link from "next/link";
import { LinkProps } from "./Link.types";
import { trackEventWithCommonProps, EventType } from "@utils/eventTracker";
import { getLoginUrl } from "@utils/getLoginUrl";

const CustomLink = forwardRef<HTMLAnchorElement, LinkProps>(
  (
    {
      className,
      onClick,
      children,
      href,
      loginlink,
      segmentEventProps,
      ...props
    },
    ref
  ) => {
    const handleLinkClick = async () => {
      // Track segment event if props are provided
      if (segmentEventProps) {
        const { eventName, eventProperties = {}, pageType } = segmentEventProps;

        await trackEventWithCommonProps(eventName, EventType.TRACK_EVENT, {
          pageType: pageType,
          additionalProps: eventProperties,
        });
      }

      if (onClick) {
        onClick();
      }
    };

    const finalHref = loginlink ? getLoginUrl(window.location.href) : href || "#";

    return (
      <Link
        href={finalHref}
        className={className || ""}
        ref={ref}
        onClick={handleLinkClick}
        {...props}
      >
        {children}
      </Link>
    );
  }
);

CustomLink.displayName = "CustomLink";

export default CustomLink;
export { CustomLink }; 